<template>
    <div class="dashboard-container">
        <rounded-container variant="dark" v-if="assets.length">
            <template v-slot:title>
                Overview
            </template>

            <list-assets-table 
                ref="assetTable" 
                :assetList="assets.filter(asset => 
                    asset.conviction === '100k'
                    )" 
                />
        </rounded-container>

        <!-- Actionable Positions Table -->
        <positions 
            @suggest-buy="triggerBuyModal"
        />
        
        <last-added-positions :positionList="positionList" />

        <div class="pricing-mode text-center small mt-3">
            <span :class="{ 'text-secondary': isRealtime }">delayed</span>
            <b-form-checkbox v-model="isRealtime" switch class="d-inline-block mx-1" />
            <span :class="{ 'text-secondary': !isRealtime }">real-time</span>
        </div>
    </div>
</template>

<script>

import Positions from "../components/Positions.vue";
import LastAddedPositions from '../components/widgets/LastAddedPositions.vue';
import RoundedContainer from '../components/style/RoundedContainer.vue';
import ListAssetsTable from '../components/asset/ListAssetsTable.vue';

import { PRICING_MODE } from '@/constants/sync';

export default {
    name: "Dashboard",
    props: ['positionList', 'assets'],
    components: {
        Positions,
        LastAddedPositions,
        ListAssetsTable,
        RoundedContainer,
    },
    computed: {
        isRealtime: {
            get() {
                return this.$store.state.pricingMode === PRICING_MODE.REALTIME;
            },
            set(on) {
                this.$store.dispatch('changePricingMode', on ? PRICING_MODE.REALTIME : PRICING_MODE.DELAYED);
            },
        },
    },
    methods: {
        triggerBuyModal(symbol) {
            this.$emit('suggest-buy', symbol)
        },
    }
};
</script>

